export class GetGeoTopoHole {
    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);

            this.id = json.Id ?? json.id;
            this.name = json.Name ?? json.name;
            this.stations = json.Stations ?? json.stations;

            delete this['Name'];
            delete this['Id'];
            delete this['Stations'];
        }
    }

    id: number;
    name: string;
    stations: number[];
}
